import { render, staticRenderFns } from "./DeliveryDetailsWrap.vue?vue&type=template&id=d60d4ebe&scoped=true"
import script from "./DeliveryDetailsWrap.vue?vue&type=script&lang=js"
export * from "./DeliveryDetailsWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60d4ebe",
  null
  
)

export default component.exports